import { AddSquareIcon } from "assets/icons";
import { If } from "components";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "ui";

import { AttributeBlockProps } from "./AttributeBlock.types";

import styles from "./AttributeBlock.module.scss";

const AttributeBlock = ({
  children,
  title,
  subtitle,
  appendLabel,
  onAppend
}: AttributeBlockProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles["attribute-block"]}>
      <If condition={title}>
        <div className={styles["attribute-block__header"]}>
          <h2 className={styles["attribute-block__header--title"]}>
            {title && t(title)}
          </h2>
          <h4 className={styles["attribute-block__header--subtitle"]}>
            {subtitle && t(subtitle)}
          </h4>
        </div>
      </If>

      {children}

      <If condition={onAppend}>
        <Button
          type="button"
          variant="default"
          icon={<Icon as={AddSquareIcon} boxSize={18} color="#090914" />}
          onClick={onAppend}
        >
          {appendLabel && t(appendLabel)}
        </Button>
      </If>
    </div>
  );
};

export default AttributeBlock;
